import { useTranslation } from 'react-i18next';
import Chip from '../../Fundamentals/Chip/Chip';
import ComboBox from '../../Fundamentals/ComboBox/ComboBox';
import FormField from '../../Fundamentals/Form/FormField';
import TagInput from '../../Fundamentals/TagInput/TagInput';
import type { PackageDraft, TargetGroupOption } from './Packages.types';

interface PackageAudienceFieldsProps {
    audiences: string[];
    targetGroupIds: string[];
    targetGroupOptions: TargetGroupOption[];
    onChange: (change: Partial<PackageDraft>) => void;
    audiencesLocked?: boolean;
}

const PackageAudienceFields = ({ audiences, targetGroupIds, targetGroupOptions, onChange, audiencesLocked = false }: PackageAudienceFieldsProps) => {
    const { t } = useTranslation();

    return (
        <>
            <FormField label={t('packages.audiences') ?? ''} htmlFor="package-audiences" help={t('packages.audiencesHelp') ?? ''}>
                <TagInput
                    id="package-audiences"
                    values={audiences}
                    disabled={audiencesLocked}
                    placeholder={t('packages.audiencesPlaceholder') ?? ''}
                    onChange={(values) => onChange({ audiences: values })}
                />
            </FormField>

            <div className="form-group">
                <ComboBox
                    id="package-target-groups"
                    label={t('packages.targetGroups')}
                    className="mb-8"
                    placeholder={t('packages.targetGroupsPlaceholder')}
                    multiPlaceholder={t('packages.targetGroupsPlaceholder')}
                    options={targetGroupOptions}
                    valueKey="id"
                    labelKey="name"
                    isMulti
                    hideInternalChips
                    value={targetGroupIds}
                    onChange={(values) => onChange({ targetGroupIds: values as string[] })}
                />
                <span className="help-block font-size-xs">{t('packages.targetGroupsHelp')}</span>
                {targetGroupIds.length > 0 && (
                    <div className="d-flex flex-wrap gap-4 mt-8">
                        {targetGroupIds.map((id) => (
                            <Chip
                                key={id}
                                label={targetGroupOptions.find((group) => group.id === id)?.name ?? id}
                                onRemove={() => onChange({ targetGroupIds: targetGroupIds.filter((value) => value !== id) })}
                            />
                        ))}
                    </div>
                )}
            </div>
        </>
    );
};

export default PackageAudienceFields;
